import actionTypes from 'constants/actionTypes';

import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

import { AddCoOwnerModalContextType } from '../types/AddCoOwnerModalContextType';

export const addCoOwnerModalInitValue: AddCoOwnerModalContextType = {
  data: {
    modalActionType: actionTypes.ADD,
    selectedPartner: null,
    name: '',
    cif: '',
    email: '',
    percentage: 0,
    comments: '',
    partnerOptions: [],
    hasMembersSelector: false,
    isValidPercent: false,
    isValidEmail: false,
    hasBeenEdited: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeSelectedPartner(): void {},
    handleChangeName(): void {},
    handleChangeCif(): void {},
    handleChangeEmail(): void {},
    handleChangePercentage(): void {},
    handleChangeComments(): void {},
    handleFetchPartnersByTerm(): Promise<
      CustomAsyncSelectOption[] | undefined
    > {
      return Promise.resolve([]);
    },
    handleSave(): void {},
  },
};
